import angular from 'angular';
import constants from 'app/constants';
import {
  pmDataService,
  pmSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './completed-document-attachment.controller';
import directive from './completed-document-attachment.directive';


export default angular.module('app.components.advisory.pm.completedDocumentAttachment', [
  alerts,
  pmDataService,
  pmSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('pmCompletedDocumentAttachment', directive)
  .controller('CompletedDocumentAttachmentController', controller)
  .name;

console.log('app.components.advisory.pm.completedDocumentAttachment created');
